<template>
  <div class="process">
    <h2>发展历程</h2>
    <p></p>

    <div class="swiper-content">
      <div class="process-swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in developList"
            :key="item.id"
          >
            <div v-if="index % 2 == 0" class="item">
              <p v-if="item.id !== 26" class="year">{{ item.year }}</p>
              <h3 v-if="item.id !== 26">{{ item.title }}</h3>
              <p v-if="item.id !== 26" class="desc" v-html="item.account"></p>
              <img v-if="item.id !== 26" src="../../static/images/about/shang.png" alt="" />
            </div>
            <div class="item" v-else>
              <img src="../../static/images/about/xia.png" alt="" />
              <p class="year">{{ item.year }}</p>
              <h3>{{ item.title }}</h3>
              <p class="desc" v-html="item.account"></p>
            </div>
          </div>
        </div>
        <div class="year-content" data-swiper-parallax-x="-540"></div>
      </div>
      <span class="process-swiper-button-prev"></span>
      <span class="process-swiper-button-next"></span>
      <div class="separate"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Process",
  props: {
    developList: Array,
  },
  data() {
    return {};
  },
  created() {
  },
  mounted() {
    // console.log(this.developList)
  },
  methods: {
    imgSwiper() {
      var process_swiper = new Swiper(".process-swiper-container", {
        slidesPerView: 5,
        parallax: true,
        autoheight: true,
        navigation: {
          nextEl: ".process-swiper-button-next",
          prevEl: ".process-swiper-button-prev",
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';
@import '~styles/mixins.styl';

.separate {
  height: 3px;
  background-color: #FFC000;
  width: 1400px;
}

.process >>> .process-swiper-container {
  .swiper-wrapper {
    position: relative;
    padding-bottom: 24.8%;
    height: 0;

    .swiper-slide {
      position: relative;
      height: 100%;
      padding-left: 8px;
      margin-left:-50px;

      p.year {
        text-align: center;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 320px;
      }
    }

    .swiper-slide:nth-of-type(2n+1) {
      padding-top: 32px;
    }

    .swiper-slide:nth-of-type(1), .swiper-slide:nth-of-type(3) {
      padding-top: 20px;
    }

    .swiper-slide:nth-of-type(2n) {
      padding-top: 338px;
    }
  }
}

.swiper-button-disabled {
  opacity: 0.4;
}

.process {
  position: relative;
  text-align: center;

  h2 {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    letter-spacing: 2px;
  }

  >p:first-of-type {
    border-bottom: 1px solid #F5BA1A;
    margin: 24px auto 0;
    width: 42px;
    height: 2px;
  }

  .swiper-content {
    position: relative;
    width: 1440px;
    margin: 0 auto;
    box-sizing: border-box;
    text-align: left;
    overflow: hidden;
    padding: 10px 40px 80px;
    height: 650px;
    background: url('../../static/images/about/beijing.png') no-repeat center center;

    h3 {
      margin: 32px 0 22px;
      text-align: center;
      letter-spacing: 1px;
      font-size: 16px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
    }

    p.desc {
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      min-height: 128px;
      height: 128px;
      margin-bottom: 23px;
    }

    img {
      display: block;
    }

    .img-box {
      position: relative;
      width: 100%;
      padding-top: 10%;
      padding-bottom: 44%;

      >img:first-of-type {
        position: absolute;
        left: 18%;
        margin: 0 auto;
        width: 40%;
        border-radius: 50%;
      }
    }

    >span {
      position: absolute;
      bottom: 280px;
      display: block;
      width: 24px;
      height: 40px;
      z-index: 10;
    }

    >span:first-of-type {
      background: url('../../static/images/about/xiangzuo1.png');
      left: 40px;
      cursor: pointer;
    }

    >span:last-of-type {
      right: 0px;
      background: url('../../static/images/about/xiangyou1.png');
      cursor: pointer;
    }

    .year-content {
      position: absolute;
      width: 7200px;
      font-size: 38px;
      bottom: 5px;
      color: #666;

      span {
        display: inline-block;
        width: 280px;
        text-indent: 1.6em;
        font-family: 'BigYoungBoldGB2.0';
        letter-spacing: 2px;
      }
    }

    >i {
      position: absolute;
      top: 50%;
      line-height: 2em;
      margin-top: -1em;
    }

    >i:first-of-type {
      right: 0;
    }

    >i:last-of-type {
      left: 0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/AboutProcess.vue